import { useEffect, useState } from 'react'
import { api } from '../api.js'

export default function Publication({ onFini }) {
  const [data, setData] = useState(null)
  const [enCours, setEnCours] = useState(false)
  const [aRouvrir, setARouvrir] = useState([])

  const charger = () => api.publishPreview().then(setData)
  useEffect(() => { charger() }, [])   // eslint-disable-line

  if (!data) return <p className="chargement">Chargement…</p>

  async function publier() {
    setEnCours(true)
    await api.publish(aRouvrir)
    setARouvrir([])
    await charger()
    onFini?.()
    setEnCours(false)
  }

  return (
    <>
      <h1>Mettre le portail à jour</h1>
      <p className="chapo">Voici ce qui va changer pour les habitants. Les dossiers déjà déposés
        continuent leur route sur la version qu'ils ont connue.</p>

      {data.suspended?.length > 0 && (
        <section className="carte suspension">
          <h2>{data.suspended.length} démarche{data.suspended.length > 1 ? 's' : ''} suspendue{data.suspended.length > 1 ? 's' : ''}</h2>
          <p className="aide">Elles resteront hors du portail après la mise en ligne. Cochez
            celles que cette mise à jour permet de rouvrir.</p>
          <ul className="liste-suspendues">
            {data.suspended.map((f) => (
              <li key={f.key}>
                <label className="case">
                  <input type="checkbox" checked={aRouvrir.includes(f.key)}
                         onChange={(e) => setARouvrir(e.target.checked
                           ? [...aRouvrir, f.key]
                           : aRouvrir.filter((k) => k !== f.key))} />
                  <span>
                    <strong>{f.title}</strong>
                    {f.reason && <span className="aide">{f.reason}</span>}
                    {f.by && <span className="aide">Suspendue par {f.by}
                      {f.at && ` le ${new Date(f.at).toLocaleDateString('fr-FR')}`}</span>}
                  </span>
                </label>
              </li>
            ))}
          </ul>
        </section>
      )}

      <div className="deux">
        <section className="carte">
          <h2>{data.changes.length ? `${data.changes.length} changement${data.changes.length > 1 ? 's' : ''}` : 'Aucun changement'}</h2>
          {data.changes.length ? (
            <>
              <ul className="changements">
                {data.changes.map((c, i) => (
                  <li key={i}><span className={`pk ${c.kind}`}>
                    {{ add: 'nouveau', mod: 'modifié', del: 'retiré' }[c.kind]}</span>{c.text}</li>
                ))}
              </ul>
              <button className="btn pri" onClick={publier} disabled={enCours}>
                {enCours ? 'Mise en ligne…'
                  : aRouvrir.length
                    ? `Mettre en ligne et rouvrir ${aRouvrir.length} démarche${aRouvrir.length > 1 ? 's' : ''}`
                    : 'Mettre en ligne maintenant'}
              </button>
            </>
          ) : <p className="aide">Votre brouillon et la version publique sont identiques.</p>}
        </section>

        <aside className="carte">
          <h2>Historique</h2>
          {data.history.length ? data.history.map((p, i) => (
            <details key={i}>
              <summary>{new Date(p.at).toLocaleString('fr-FR')} · {p.changes.length} changement(s)</summary>
              <ul>{p.changes.map((c, j) => <li key={j}>{c}</li>)}</ul>
            </details>
          )) : <p className="aide">Portail jamais mis en ligne.</p>}
        </aside>
      </div>
    </>
  )
}
